import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import CloseCross from "@catchy/assets/svgs/close-cross.svg";
import ExternalLink from "@catchy/assets/svgs/external-link.svg";
import IconButton from "./IconButton";
const URL_REGEX = /(https?:\/\/[^\s<]+)/g;
function formatAlertText(text) {
  if (typeof text !== "string" || !text.trim()) {
    return null;
  }
  return text.trim().split(/\r\n|\r|\n/).map((line, i) => {
    const words = line.split(URL_REGEX);
    return <p key={i}>
          {words.map((word, j) => {
        if (word.match(URL_REGEX)) {
          return <Link key={j} href={word} className="font-semibold underline decoration-zinc-900/30 decoration-1 underline-offset-2 dark:decoration-white/30">
                  {word}
                </Link>;
        }
        return word;
      })}
        </p>;
  });
}
const Alert = t0 => {
  const $ = _c(26);
  const {
    alert_id,
    severity_level,
    header_text,
    description_text,
    url,
    dismissable: t1,
    dismissedAlerts: t2,
    setDismissedAlerts
  } = t0;
  const dismissable = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const dismissedAlerts = t3;
  const t4 = `relative mx-[20px] flex flex-row rounded-lg p-4 ring-2 ring-inset ${severity_level === "INFO" ? "bg-blue-50 p-4 ring-2 ring-inset ring-blue-300 dark:bg-blue-800 dark:ring-blue-900" : "bg-rose-50 ring-rose-300 dark:bg-rose-800 dark:ring-rose-900"}`;
  let t5;
  if ($[2] !== description_text || $[3] !== dismissable || $[4] !== header_text) {
    t5 = description_text && <h2 className={`text-pretty text-lg font-bold leading-5 ${dismissable ? "pr-8" : ""}`}>{header_text}</h2>;
    $[2] = description_text;
    $[3] = dismissable;
    $[4] = header_text;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `flex flex-col gap-y-2 leading-tight ${!description_text ? "pr-8" : ""}`;
  const t7 = description_text || header_text;
  let t8;
  if ($[6] !== t7) {
    t8 = formatAlertText(t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t6 || $[9] !== t8) {
    t9 = <div className={t6}>{t8}</div>;
    $[8] = t6;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== url) {
    t10 = url && <div className="w-full"><Link href={url} target="_blank" className="flex items-start text-blue-500 dark:text-white"><ExternalLink className="mr-2 mt-1 inline-block h-3 w-3 shrink-0" /><div className="flex flex-wrap leading-tight"><span className="mr-1 shrink-0 font-semibold">More information</span><span>({new URL(url).hostname})</span></div></Link></div>;
    $[11] = url;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t5 || $[15] !== t9) {
    t11 = <div className="flex w-full flex-col gap-y-2">{t5}{t9}{t10}</div>;
    $[13] = t10;
    $[14] = t5;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== alert_id || $[18] !== dismissable || $[19] !== dismissedAlerts || $[20] !== setDismissedAlerts) {
    t12 = dismissable && <IconButton label="Dismiss alert" variant="subtle" onClick={() => setDismissedAlerts([alert_id, ...dismissedAlerts])} className="absolute right-2 top-2"><CloseCross className="h-[0.8125rem] w-[0.8125rem]" aria-hidden="true" /></IconButton>;
    $[17] = alert_id;
    $[18] = dismissable;
    $[19] = dismissedAlerts;
    $[20] = setDismissedAlerts;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12 || $[24] !== t4) {
    t13 = <div className={t4}>{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t4;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};
export default Alert;